import { TGuest } from 'interfaces/user.interfaces';
import { IPatientView } from 'interfaces/patients.interfaces';
import { ISectionCondition } from '../interfaces/form.interfaces';

const evaluateSectionCondition = (
  condition: ISectionCondition,
  customer: IPatientView | null,
): boolean => {
  const { type, field, operator, value } = condition;
  let customerValue: any;

  switch (type) {
    case 'customer':
      if (!customer) return false;
      customerValue = customer[field as keyof typeof customer];
      switch (operator) {
        case 'equals':
          return customerValue === value;
        case 'notEquals':
          return customerValue !== value;
        case 'in':
          return Array.isArray(value) && value.includes(customerValue);
        case 'notIn':
          return Array.isArray(value) && !value.includes(customerValue);
        case 'greaterThan':
          return typeof customerValue === 'number' && customerValue > value;
        case 'lessThan':
          return typeof customerValue === 'number' && customerValue < value;
        case 'exists':
          return customerValue !== undefined && customerValue !== null;
        case 'notExists':
          return customerValue === undefined || customerValue === null;
        default:
          return false;
      }

    default:
      return false;
  }
};

export const shouldDisplaySection = (
  conditions: ISectionCondition[] | undefined,
  customer: IPatientView | null,
  guest?: TGuest | null,
): boolean => {
  if (!conditions?.length) return true;

  if (guest) {
    return conditions.every(condition => evaluateSectionCondition(condition, guest));
  }

  return conditions.every(condition => evaluateSectionCondition(condition, customer));
};
